/**
 * Beta feedback context capture utility
 * Minimal context following George's recommendations
 */

export interface BetaFeedbackContext {
  user_id: string;
  email: string;
  user_level: string;
  current_url: string;
  app_version: string;
}

export function captureFeedbackContext(user: any): BetaFeedbackContext {
  return {
    user_id: user.id,
    email: user.email,
    user_level: user.user_level,
    current_url: window.location.href,
    app_version: import.meta.env.VITE_APP_VERSION || 'dev'
  };
}

export function formatContextForMessage(context: BetaFeedbackContext): string {
  return `

--- Auto-captured context ---
URL: ${context.current_url}
App Version: ${context.app_version}`;
}